export const getColumnCount = (numColumns, selectable) => numColumns + (selectable ? 1 : 0);